import {HTTPService} from './http.service';
import {Injectable} from "@angular/core";
import { Assignment } from '../models/Assignment';

@Injectable()
export class PdfService {

    constructor(private http:HTTPService) {

    }


    public getPDFUrl(filePrintId:string) {
        let addToken = true;
        return this.http.generateUrl("/pdf/download/" + filePrintId, addToken);
    }

    public generate(url:string, assignment?:Assignment) {
        let window = document.defaultView || null;
        if (!window) {
            return Promise.reject("Window missing from document.  Cannot proceed");
        }

        let data:any = {
            pageToGenerate:url
        };
        // TODO: stephen our single assessment result viewer is not being connected with any reports
        // that seems like a problem to me... 
        if (assignment) {
            data.assignmentId = assignment.Id
            data.type = assignment.Type
        };
        return this.http.post("/pdf/", data).then((response) => {
            let data = response.json() as {fileId:string};
            if (data.fileId) {
                return data.fileId;
            }
            else {
                throw new Error("Failed to receive file print id");
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/services/pdf.service.ts